module.exports = __webpack_public_path__ + "img/cle1.d408205c.png";